import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { ItemData } from './KanbanBoard';

interface KanbanItemProps {
  item: ItemData;
}

export function KanbanItem({ item }: KanbanItemProps) {
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id: item.id,
    data: {
      type: 'Item',
      item,
    },
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  if (isDragging) {
    return (
      <div
        ref={setNodeRef}
        style={style}
        className="relative border-2 border-dashed border-primary/50 bg-primary/5 dark:bg-primary/10 rounded-xl min-h-[5.5rem] w-full flex items-center justify-center transition-all duration-150 shadow-inner"
      >
        <div className="flex items-center gap-1.5 text-xs font-medium text-primary/70 select-none">
          <div className="h-1.5 w-1.5 rounded-full bg-primary/70 animate-ping" />
          <span>Drop here</span>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="cursor-grab hover:shadow-md transition-all duration-150 active:cursor-grabbing rounded-xl"
    >
      {item.content}
    </div>
  );
}
